import React, { useEffect, useRef } from 'react';
import { Icon, Segment, Table, Pagination, Dropdown } from 'semantic-ui-react';
import { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../app/stores/store';
import { Link } from 'react-router-dom';
import '../../app/common/MediaQuery/responsive-table-style.css';
import SearchInputData from './SearchInputData';
import SortData from './SortData';
import DynamicTableCSVReport from './DynamicTableCSVReport';
import ReportsModalForMetaData from '../TableReports/ReportsModalForMetaData';
import agent from '../../app/api/agent';
import { toast } from 'react-toastify';
import { WorkFlowTask, WorkFlowTemplate } from '../../app/models/template';
import LoadingComponent from '../../app/layout/LoadingComponent';
import SmartTrackerButtonConfig from '../SmartTracker/SmarttrackerButtonconfig';
import SmarttrackerComponents from '../SmartTracker/SmarttrackerComponents';
import _ from 'lodash';
import { defaultRow } from '../SmartTracker/smarttrackerType';
import { reAllocationInitialState, reAllocationTypes } from '../../app/stores/CRMStore/types';

interface Props {
  data: any;
  name: any;
  actiontype: string;
  pageFunc: any; //func
  pageNumData: number;
  searchFuncData: any; //func
  DropdownParentAll?: string;
  dropDowndata?: any;
  getNewDetails?: any;
  //
  currentTitle_Code?: {
    value: string;
    list: {
      key: string;
      value: string;
      text: string;
    }[];
  };
  currentSubTask?:any
  setCurrentTitle_Code?: any;
  currentPl_id?: {
    value: string;
    list: {
      key: string;
      value: string;
      text: string;
    }[];
  };
  setCurrentPl_id?: any;
  currentDisplayName?: {
    value: string;
    list: {
      key: string;
      value: string;
      text: string;
    }[];
  };
  setCurrentDisplayName?: any;
  clickTaskHandler?:any;
  setPageNumber?:any;
  filters?:any
  // completeAPIHandler?: any;
}

/* Sort - End*/
function DynamicTableComponentForMetaData({
  data,
  name,
  pageFunc,
  pageNumData,
  DropdownParentAll,
  dropDowndata,
  getNewDetails,
  setCurrentTitle_Code,
  currentTitle_Code,
  currentPl_id,
  setCurrentPl_id,
  currentDisplayName,
  setCurrentDisplayName,
  clickTaskHandler,
  setPageNumber,
  filters
}: // completeAPIHandler,
Props) {
  const {
    dashboardStore,
    userStore: { user },
    reportStore,
    userStore,
    TrackingReportStore,
    activityStore,
    commonStore,
    NFAI_Restoration_SmartflowsStore:{titileInformation,statusButtonShow,selectedItems},
    NFAI_Restoration_SmartflowsStore,
    viewStore
  } = useStore();
  // const [currentPage, setCurrentPage] = useState<any>(1);
  const tableName = name;
  const [postsPerPage, setPostsPerPage] = useState<any>(
    tableName === 'ReportsTable' ? 10 : tableName === 'SmartTracker' ? 20 : 5,
  );
  const [sortedListItems, setSortedListItems] = useState<WorkFlowTemplate>({
    templateId: '',
    templateName: '',
    templateDateTime: '',
    isActive: false,
    tasks: [],
  });
  const [listTaskItems, setListTaskItems] = useState<WorkFlowTask[]>([]);
  const [tabledHeaders, setTableHeaders] = useState<string[]>([]);
  const [trackerRowData, setTrackerRowData] = useState<{
    current_task: string;
    current_subtask: string;
  }>({
    current_task: '',
    current_subtask: '',
  });
  const rowsOption=[
    {
    key: 1,
    text: '5',
    value: 5
    },
    {
      key: 2,
      text: '25',
      value: 25
    },
    {
      key: 3,
      text: '50',
      value: 50
    },
    {
      key: 4,
      text:'75',
      value: 75
    },
    {
      key: 5,
      text: '100',
      value: 100
    }
  ]
  const [selectedRow, setSelectedRow] = useState(rowsOption[0]?.value || '');

  const tableRef = useRef<HTMLDivElement | null>(null);
  const countData =
    tableName === 'AssetTable'
      ? dashboardStore.dashboard.inventoryCount2
      : tableName === 'ReceivingTable'
        ? dashboardStore.dashboard.receivingsCount
        : tableName === 'EmailTable'
          ? dashboardStore.dashboard.messageCount
          : tableName === 'WorkLevelTable'
            ? dashboardStore.dashboard.itemgroupsCount
            : // FFNotTableCount
            tableName === 'SmartTracker' && user?.customerName === 'NFAIReport'
            ? titileInformation.count
              : (tableName === 'ReportsTable' || tableName === 'SmartTracker') &&
                user?.customerName !== 'LVPCMS'
              ? dashboardStore.dashboard.inventoryCount2 :
              (tableName === 'ReportsTable' ||
                    tableName === 'SmartTracker') &&
                  user?.customerName === 'LVPCMS'
                ? dashboardStore.dashboard.inventoryCount2
                : data.length;
  // const tableHeads = tableHead;

  function exampleReducer(state: any, action: any) {
    switch (action.type) {
      case 'CHANGE_SORT':
        if (state.column === action.column) {
          return {
            ...state,
            // state.tabledata.slice().reverse()
            tabledata: state.tabledata.slice().reverse(),
            direction:
              state.direction === 'ascending' ? 'descending' : 'ascending',
          };
        }
        return {
          column: action.column,
          // _.sortBy(state.tabledata, [action.column])
          tabledata: _.sortBy(state.tabledata, [action.column]),
          direction: 'ascending',
          currentPages: 1,
        };
      case 'UPDATE_DATA':
        return {
          column: action.column,
          tabledata: data,
          direction: null,
          currentPages: 1,
        };

      default:
        throw new Error();
    }
  }

  const [state, dispatch] = React.useReducer(exampleReducer, {
    column: null,
    tabledata: data,
    direction: null,
    currentPages: 1,
  });
  const { tabledata } = state;
  useEffect(() => {
    setSortedListItems(TrackingReportStore?.sortedListItems);
    //eslint-disable-next-line
  }, [TrackingReportStore.sortedListItems]);

  useEffect(() => {
    setListTaskItems(TrackingReportStore.listTaskItems);
    //eslint-disable-next-line
  }, [TrackingReportStore.listTaskItems]);

  useEffect(() => {
    if (
      localStorage.getItem(tableName) !== undefined &&
      localStorage.getItem(tableName) !== null
    ) {
      let localTableHeaders: string[] = localStorage.getItem(tableName)?.split(',') || [];
      if (user?.customerName === 'NFAIReport' && user?.roleName !== 'Operator') {
        if (selectedItems.task === 'Full Restoration') {
          localTableHeaders = localTableHeaders.filter(e => e.trim() !== 'Submission_Date');
        } else if (!localTableHeaders.includes('Submission_Date')) {
          localTableHeaders.push('Submission_Date');
        }
      }
      setTableHeaders(localTableHeaders);      
    } else {
      localStorage.setItem(tableName, '');
    }
    //eslint-disable-next-line
  }, [localStorage.getItem(tableName || '')]);

  useEffect(() => {
    // dipatch is called after data is updated via props
    dispatch({ type: 'UPDATE_DATA' });
  }, [data]);

  useEffect(() => {
    if (
      reportStore.loadingDataReport ||
      dashboardStore.dashboard.loadingCount ||
      reportStore.loadMetadataReportComponent
    ) {
      let table: any = document.querySelector('.metadata-report-loader');
      if (table && table.scrollLeft !== null) {
        table.scrollLeft = 0;
        table.focus();
      }
    }
  }, [
    reportStore.loadingDataReport,
    dashboardStore.dashboard.loadingCount,
    reportStore.loadMetadataReportComponent,
  ]);



  const handleChange = () => {
    let maxLength = 0;
    let maxObjectIndex = 0;
    for (let i = 0; i <= tabledata.length - 1; i++) {
      if (Object.keys(tabledata[i]).length > maxLength) {
        maxLength = Object.keys(tabledata[i]).length;
        maxObjectIndex = i;
      }
    }

    dashboardStore.setTableClicked(
      tabledata.length > 0 ? Object?.keys(tabledata[maxObjectIndex]) : null,
      tableName,
    );
    dashboardStore.reportsConfigurationOpen(true);
  };
  /////////////// Edit Function (Receving Delivery )

  //////////////delete the receving delivery,Customer,Dept,Shelf ,Vault Device item group

  //////// function to get clicked value
  const getClickedValue = async (rowData: any, tableName: string) => {
    TrackingReportStore.isSmartTrackerButtonLoading = true;
    if (tableName === 'ReceivingTable') {
      dashboardStore.showClickedValueForReceiving(
        rowData.id,
        rowData.title,
        rowData.barcode_Package,
      );
    } else if (tableName === 'OrderRegisterTable') {
      dashboardStore.dashboard.deliveryOrderTableClicked = true;
      dashboardStore.setOrderRequestDetails(rowData);
    } else if (tableName === 'AssetTable') {
      dashboardStore.showClickedValueForAssetTable(rowData.id);
    } else if (
      tableName === 'DeliveryTableSmall' ||
      tableName === 'DeliveryTableBig'
    ) {
      dashboardStore.showClickedValueOutwardInward(rowData.id);
    } else if (
      tableName === 'OutwardsTableSmall' ||
      tableName === 'OutwardsTableBig'
    ) {
      dashboardStore.showClickedValueOutwardInward(rowData.id);
    } else if (
      tableName === 'InwardsTableSmall' ||
      tableName === 'InwardsTableBig'
    ) {
      dashboardStore.showClickedValueOutwardInward(rowData.id);
    } else if (tableName === 'AssetTableTag' || tableName === 'TagTable') {
      dashboardStore.showClickedValueForAssetTable(rowData.id);
    } else if (tableName === 'SmartTracker') {
      let result = await agent.Reports.getRolesAndPermissionTaskAndSubtask(
        rowData['id'],
      );
  
      if (result.data.length) {
        toast.info(result.data);
        return;
      }
      
      const response = await agent.viewPage.activeOrder({
        itemId: rowData['id'],
      });
      viewStore.activeOrder = response.data;
      const workflowApi = response?.data || {
        templateId: '',
        templateIndex: 0,
        templateName: '',
        templateDateTime: '',
        isActive: false,
        isDeleted: false,
        tasks: [],
      };
      const currentTasks = workflowApi.tasks?.filter((data: any) => {
        return data?.isCurrentTask === true;
      });
      const currentSubtask1 = currentTasks[0]?.subTasks?.filter((data: any) => {
        return data?.isCurrentSubtask === true;
      });

      if (['Started', 'Resume', 'Resumed'].includes(rowData['status'])) {
        let results1 = await agent.subtaskStatus.subtaskElementsAPI(
          currentSubtask1[0]?.subTaskId,
        );
        if (results1?.data?.actionerName !== userStore.user?.displayName) {
          TrackingReportStore.isSmartTrackerButtonLoading = false;
          toast.info('This workflow not permission to work on.');
          return;
        }
      }
      setTrackerRowData({
        ...trackerRowData,
        current_task: currentTasks[0].taskName,
        current_subtask: currentSubtask1[0]?.subTaskName,
      });
      // await viewStore.getActiveOrder({ itemId: rowData['id'] });
      TrackingReportStore.SortedCurrentAllItems(workflowApi);
      TrackingReportStore.bindComponent = {
        ...TrackingReportStore.bindComponent,
        defects:[]
      }
      await activityStore.loadActivity(rowData['id'], rowData['status']);
      if(commonStore.RestorationCustomer){
        const bindResponse = await TrackingReportStore.bindComponetHandler(rowData['id']);
        const defectPayload = {
          ...defaultRow[0],
          quality_EmpId: userStore?.user?.displayName,
          rejectType: rowData['titleStatus']
        }
        if (bindResponse) {
          TrackingReportStore.bindComponent = {
            ...TrackingReportStore.bindComponent,
            model: true,
            rejectHistory: bindResponse.rejectHistory,
            inputPath: bindResponse.inputOutPath?.inputPath || '',
            outputPath: bindResponse.inputOutPath?.outputPath || '',
            employeeName: bindResponse.inputOutPath?.employeeName || '',
            frrInformation:bindResponse.inputOutPath?.frrInformation || '',
            status: rowData['status'],
            empId: rowData.displayname,
            titleStatus:rowData['titleStatus'],
            reelName: rowData['reel_name'],
            shortName: rowData['shot_name'],
            startFrame: rowData['start_frame'],
            endFrame: rowData['end_frame'],
            totalFrame: rowData['total_frame'], 
            defects: (userStore.user?.roleName === 'Operator' || rowData['status'] === 'Yet_to_Start' )? [] :[defectPayload],
            current_Subtask:rowData['current_subtask'],
            PreviousEmpId: rowData['previous owner employeeId'],
          };
        }
      }
      if(commonStore.NFAIReportCustomer){
        NFAI_Restoration_SmartflowsStore.subtaskCompoent.reAllocationList = reAllocationInitialState;
        const reAllocationPayload:reAllocationTypes = {
              ...reAllocationInitialState,
              itemId: rowData['id'],
              employeeId: rowData['Emp_ID'],
              employeeName: rowData['Emp_Name'],
              startFrame: rowData['Start_Frame'],
              endFrame: rowData['End_Frame'],
              totalFrame: rowData['Total_Frames']
         }
        NFAI_Restoration_SmartflowsStore.subtaskCompoent.reAllocationList =  reAllocationPayload;
const taskDetails = {
          id: rowData['id'],
          title:activityStore?.selectedActivity?.title,
          taskName: currentTasks?.[0]?.taskName,
          subtaskName:  currentSubtask1[0]?.subTaskName,
          taskId:currentTasks?.[0]?.taskId,
          subtaskId:currentSubtask1?.[0]?.subTaskId,
          taskData: workflowApi,
          parentId: activityStore.selectedActivity?.parent?.split('|')[0] || '',
          metadata: activityStore?.selectedActivity?.metadata
        }
        let subtaskResponse = await agent.subtaskStatus.subtaskElementsAPI(
          currentSubtask1[0]?.subTaskId,
        );
        const fetchElements = async () => {
          NFAI_Restoration_SmartflowsStore.subtaskCompoent.elements =  [];
          NFAI_Restoration_SmartflowsStore.subtaskCompoent.elementCopy =  [];
          const elements = [...subtaskResponse?.data?.elements];
          const updatedElements = await Promise.all(
            elements.map(async (e) => {
              if (e.elementType === "Dynamicmetadata") {
                const params = {
                  itemId: rowData['id'],
                  templateId: response.data?.templateId || "",
                  templateElementId: e.elementValue?.split?.("|")?.[1] || "",
                };
                try {
                  const response = await agent.ElementTypes.elementDetails(params);
                  if(user?.roleName === 'Operator')  response.data.options = response.data.options.filter((item: any) => item.optionName !== "Remarks");
                  let payload = {
                    ...response.data,
                    readOnly: e?.readOnly,
                    isMandatory: e?.isMandatory,
                    enableByDefault: e?.enableByDefault,
                    isDynamic: true,
                  };
                  return payload;
                } catch (error) {
                  console.error("Error fetching element details:", error);
                  return e;
                }
              } else return e;
            })
          );
          return updatedElements;
        };
        const element = await fetchElements()   
        NFAI_Restoration_SmartflowsStore.updateInitialComponents(element,taskDetails)
        statusButtonShow(subtaskResponse.data.subTaskstatus);
      }
    
    }
    TrackingReportStore.ActiveRowId = rowData.id;
  };

  let tableheightcss =
    tableName === 'ReceivingTable' ||
    tableName === 'AssetTableTag' ||
    tableName === 'OrderRegisterTable' ||
    tableName === 'TagTable' ||
    tableName === 'DeliveryTableSmall' ||
    tableName === 'InwardsTableSmall' ||
    tableName === 'OutwardsTableSmall' ||
    tableName === 'VaultTable' ||
    tableName === 'EmailTable' ||
    tableName === 'DeviceTable' ||
    tableName === 'ShelfRackTable' ||
    tableName === 'DepartmentTable' ||
    tableName === 'WorkLevelTable' ||
    tableName === 'HistoryTable' ||
    tableName === 'OrderTable' ||
    tableName === 'AlertsTable';

  const classNameFunc1 = (data: string) => {
    if (data === 'ReportsTable') {
      return 'table-height-reports';
    } else if (data === 'SmartTracker') {
      return 'table-height-reports2';
    } else if (tableheightcss) {
      return 'table-height'; //small table
    } else {
      return 'table-height1';
    }
  };

  const classNameFunc2 = (data: string) => {
    let classname = '';
    if (
      reportStore.loadingDataReport ||
      dashboardStore.dashboard.loadingCount ||
      reportStore.loadMetadataReportComponent
    ) {
      classname = 'metadata-report-loader ';
    } else {
      classname = '';
    }

    if (data === 'ReportsTable') {
      classname += 'dynamictableoverflow-reports';
    } else if (data === 'SmartTracker') {
      classname += 'dynamictableoverflow-reports2';
    } else if (tableheightcss) {
      classname += 'dynamictableoverflow';
    } else {
      classname += 'dynamictableoverflow1';
    }
    return classname;
  };

  const closeModalHandler = async (checkedItems?: string[]) => {
    if (checkedItems && checkedItems.length > 1) {
      const values = checkedItems.map((element: any) => {
        return element.toLowerCase();
      });
      values?.push('id');
      reportStore.loadingDataReport = true;
      let results = await agent.Reports.reportsWithPaginationPost(
        pageNumData,
        10,
        values,
      );
      if (results.data === 'Item Not found') {
        toast.error(results.data);
        return;
      }
      let data = JSON.parse(results.data);
      if (data) {
        reportStore.metaDataRegistry = new Map<string, any>();
        data.forEach((activity: any) => {
          reportStore.metaDataRegistry.set(activity.id, activity);
        });
        reportStore.loadingDataReport = false;
      }
    }
  };

  function commonSearch(name: string) {
    //  Hierarchy
    const tablename = name;
    if (
      Object.values(dashboardStore.dashboard.searchfilterparams).every(
        (o) => o === '',
      )
    ) {
      let ReportTableChosen: any = localStorage.getItem(tablename);
      let chosenArr = ReportTableChosen.split(',');
      chosenArr.push('id');
      const lower = chosenArr.map((element: any) => {
        return element.toLowerCase();
      });
      return {
        value: lower,
        type: 'empty',
      };
    } else {
      // if search is not empty --->>>> and Header table contains  many value
      let ReportTableChosen = localStorage.getItem(name);
      if (ReportTableChosen?.split(',')) {
        let ReportTableChosenId = ReportTableChosen?.split(',');
        ReportTableChosenId.push('id');
        const lower = ReportTableChosenId.map((element) => {
          return element.toLowerCase();
        });
        return {
          value: lower,
          type: 'manySearchValues',
        };
      } else {
        // if search is not empty --->>>> and Header table contains only one value
        let ReportTableChosenId = [ReportTableChosen];
        ReportTableChosenId.push('id');
        const lower = ReportTableChosenId.map((element: any) => {
          return element.toLowerCase();
        });
        return {
          value: lower,
          type: 'singleSearchValue',
        };
      }
    }
  }

  // if (reportStore.loadMetadataReportComponent) return <LoadingComponent />;
  return (
    <p>
      {name === 'SmartTracker' && user?.customerName !== 'NFAIReport' && (
        <SmartTrackerButtonConfig
          clickTaskHandler={clickTaskHandler}
          rowDataId={TrackingReportStore.ActiveRowId}
          trackerRowData={trackerRowData}
          commonSearch={commonSearch('SmartTracker')}
          sortedListItems={sortedListItems}
          getNewDetails={getNewDetails}
          pageNumData={pageNumData}
          listTaskItems={listTaskItems}
          setListTaskItems={setListTaskItems}
          currentTitle_Code={currentTitle_Code}
          setCurrentTitle_Code={setCurrentTitle_Code}
          currentPl_id={currentPl_id}
          setCurrentPl_id={setCurrentPl_id}
          currentDisplayName={currentDisplayName}
          setCurrentDisplayName={setCurrentDisplayName}
          setPageNumber={setPageNumber}
          // completeAPIHandler={completeAPIHandler}
        />
      )}
      {window.innerWidth > 768 ? (
        <Segment className={classNameFunc1(tableName)}>
          <Segment
            tabIndex="1"
            ref={tableRef}
            className={classNameFunc2(tableName)}
          >
            {dashboardStore.dashboard.reportsConfiguration === true ? (
              <ReportsModalForMetaData closeModalHandler={closeModalHandler} />
            ) : null}
            <Table
              sortable
              selectable
              celled
              singleLine
              padded={
                tableheightcss ||
                tableName === 'ReportsTable' ||
                tableName === 'SmartTracker'
                  ? 'very'
                  : false
              }
            >
              <Table.Header>
                {name !== 'SmartTracker' && (
                  <Table.Row>
                    {localStorage
                      .getItem(tableName)
                      ?.split(',')
                      .map((tablehead: string, index: number) => {
                        
                        if (userStore.user?.customerName !== "TNCA") {
                          return (
                            <Table.HeaderCell style={{ minWidth: '50px' }} key={index}>
                              <SearchInputData
                                tablehead={tablehead}
                                tablename={tableName}
                                index={index}
                                loader={
                                  !(
                                    reportStore.loadingDataReport ||
                                    dashboardStore.dashboard.loadingCount ||
                                    reportStore.loadMetadataReportComponent
                                  )
                                }
                              />
                            </Table.HeaderCell>
                          );
                        } else {
                          return null
                        }
                      })}
                  </Table.Row>
                )}
              </Table.Header>
              <Table.Header>
                <Table.Row>
                  {tabledHeaders?.map((tablehead: any) => {
                    return (
                      <Table.HeaderCell
                        style={{
                          padding:
                            name === 'SmartTracker' &&
                            '0.4em 0.4em 0.7em 0.4em',
                        }}
                      >
                        <SortData
                          header={tablehead}
                          tableName={tableName}
                          pageNum={pageNumData}
                          chosenHeader={tabledHeaders}
                          name={name}
                          sortHandler={() => {}}
                        />
                      </Table.HeaderCell>
                    );
                  })}
                  {/* 
                  {tableHeads.length > 0
                    ? // You have an array
                    localStorage.getItem("ReportsTable")?.split(",")?.map((i: any, index: number) =>
                          i !== "id" ? (
                            <Table.HeaderCell key={index}>
                              {reactStringReplace(
                                (
                                  i.charAt(0).toUpperCase() +
                                  i.slice(1).split("_").join(" ")
                                )
                                  .split(" ")
                                  .map(
                                    (i: any) =>
                                      i.charAt(0).toUpperCase() +
                                      i.slice(1) +
                                      ""
                                  ),
                                /([A-Z])/,
                                (m: any) => " " + m
                              )}
                            </Table.HeaderCell>
                          ) : null
                        )
                    : {}} */}
                </Table.Row>
              </Table.Header>
              {NFAI_Restoration_SmartflowsStore.loader.tableLoader || 
              reportStore.loadingDataReport ||
              dashboardStore.dashboard.loadingCount ||
              reportStore.loadMetadataReportComponent ||
              TrackingReportStore.bindComponent.loader ? (
                <LoadingComponent />
              ) : (
                // <LoadingComponent />
                <Table.Body className="tabletexttruncate">
                  {tabledata
                    // .filter(filterFunc)
                    ?.slice(
                      parseInt(state.currentPages, 10) *
                        parseInt(postsPerPage, 10) -
                        parseInt(postsPerPage, 10),
                      parseInt(state.currentPages, 10) *
                        parseInt(postsPerPage, 10),
                    )?.length !== 0 ? (
                    tabledata
                      // .filter(filterFunc)
                      .slice(
                        parseInt(state.currentPages, 10) *
                          parseInt(postsPerPage, 10) -
                          parseInt(postsPerPage, 10),
                        parseInt(state.currentPages, 10) *
                          parseInt(postsPerPage, 10),
                      )
                      .map((rowData: any) => (
                        <Table.Row
                          style={{ padding: '0px' }}
                          key={rowData.id}
                          active={
                            rowData['id'] === TrackingReportStore.ActiveRowId
                          }
                          onClick={() => getClickedValue(rowData, tableName)}
                          // onMouseOver={() => setHoverRowId(rowData["id"])}
                        >
                          {!reportStore.loadingDataReport &&
                            tabledHeaders?.map((i: any) => {
                              rowData[i] = rowData[i]
                                ?.replace('&#x0022;', '"')
                                ?.replace('&#x005D;', ']')
                                ?.replace('&#x005B;', '[')
                                ?.replace('0xFE5B', '{')
                                ?.replace('0xFE5C', '}')
                                ?.replace('U+003B', ';')
                                ?.replace('U+006E', '')
                                ?.replace('U+003A', ':');
                              return (
                                <>
                                  {i === 'title' ||
                                  i.toLowerCase() === 'metadata/ title_code' ||
                                  i.toLowerCase() === 'film_title'? (
                                    <Table.Cell
                                      key={i}
                                      style={name === 'SmartTracker' ? {
                                        padding:'0.1em 0.4em 0.1em 0.2em'} : {}}
                                    >
                                      {user?.customerName === 'NFAIReport' && user?.roleName === 'Operator' ? (
                                    <div>
                                      {i.toLowerCase() === 'film_title'
                                        ? rowData['Film_Title'] : <></>}
                                    </div>
                                  ) : (
                                    <Link to={`/mediaAssets/${rowData['id']}`}>
                                      {i.toLowerCase() === 'metadata/ title_code'
                                        ? rowData['title_code']
                                        : i.toLowerCase() === 'film_title'
                                        ? rowData['Film_Title']
                                        : rowData['title']}
                                    </Link>
                                  )}

                                    </Table.Cell>
                                  ) : (
                                    <Table.Cell
                                      key={i}
                                      style={i.toLowerCase() === 'input_path' || i.toLowerCase() === 'output_path'  ? { maxWidth:'150px',padding: '0.1em 0.4em 0.1em 0.2em' } : {
                                        padding:
                                          name === 'SmartTracker' &&
                                          '0.1em 0.4em 0.1em 0.2em',
                                      }}
                                    >
                                      {i === 'parent' ? (
                                        <Link
                                          to={`/mediaAssets/${
                                            rowData['parent'].split('/')[0]
                                          }`}
                                        >
                                          {rowData['parent'].split('/')[1]}
                                        </Link>
                                      ) : i.includes('metadata/') === true ? (
                                        <span
                                          key={i
                                            ?.split('/')[1]
                                            ?.trim()
                                            .replaceAll(/ /g, '_')}
                                        >
                                          {rowData[
                                            i
                                              ?.split('/')[1]
                                              ?.trim()
                                              ?.replaceAll(/ /g, '_')
                                              ?.toLowerCase()
                                          ]
                                            ?.replaceAll('&#x29F5U+003B', '\\')
                                            ?.replaceAll('U+003A', ':')}
                                        </span>
                                      ) : i.includes('file_Name') ? ( 
                                        <Link  to={`/mediaAssets/${rowData['id']}`}>
                                          {rowData['file_Name']}
                                        </Link>): 
                                      (rowData[i])}
                                    </Table.Cell>
                                  )}
                                </>
                              );
                            })}
                        </Table.Row>
                      ))
                  ) : (
                    <Table.Row
                      style={{
                        height: '20vh',
                        overflow: 'hidden',
                      }}
                    >
                      <Table.Cell
                        colSpan={
                          data.length > 0 ? Object.keys(data[0]).length : 9
                        }
                        collapsing
                      >
                        <p
                          className={'tableEmptyData-smart'}
                        >Sorry, no data to show</p>
                      </Table.Cell>
                    </Table.Row>
                  )}
                </Table.Body>
              )}
            </Table>
          </Segment>
          <Segment raised attached="top">
            <div className="dynamicTableFooter">
              <Pagination
                disabled={
                  reportStore.loadingDataReport ||
                  dashboardStore.dashboard.loadingCount ||
                  reportStore.loadMetadataReportComponent
                }
                activePage={pageNumData}
                totalPages={Math.ceil(countData / postsPerPage)}
                onPageChange={(event, data) => pageFunc(data.activePage)}
              />
              <div>
                {/* {name !== 'SmartTracker' && (
                  <>
                    <Dropdown
                      upward
                      options={currentTask.list}
                      selection
                      clearable
                      placeholder="Task"
                      onChange={(_event: any, data: any) => {
                        setCurrentTask({
                          ...currentTask,
                          value: data.value,
                        });
                        setCurrentSubTask({
                          value: '',
                          list: [],
                        });
                        if (data.value === '') {
                          let titles =
                            localStorage
                              .getItem(
                                name === 'SmartTracker'
                                  ? 'SmartTracker'
                                  : 'ReportsTable',
                              )
                              ?.split(',') || [];
                          titles.push('id');
                          reportStore.loadReportPagination(1, titles, name);
                          dashboardStore.updateCountOrderMenu(
                            userStore.user!.id,
                          );
                        }
                        TrackingReportStore.statusButtonShow('');
                      }}
                      value={currentTask.value}
                    />
                    <Dropdown
                      upward
                      clearable
                      options={currentSubTask.list}
                      selection
                      placeholder="Subtask"
                      onChange={(_event: any, data: any) => {
                        TrackingReportStore.statusButtonShow('');
                        setCurrentSubTask({
                          ...currentSubTask,
                          value: data.value,
                        });
                      }}
                      value={currentSubTask.value}
                    />
                    <Dropdown
                      upward
                      options={Dropdownoptions}
                      selection
                      placeholder="Hierarchy"
                      onChange={(_event: any, data: any) => {
                        setCurrentTask({
                          value: '',
                          list: [],
                        });
                        setCurrentSubTask({
                          value: '',
                          list: [],
                        });
                        DropdownReport(_event, data);
                      }}
                      value={DropdownParentAll}
                    />
                  </>
                )} */}
                {name !== 'SmartTracker' && (
                  <div style={{display: 'flex'}}>
                    {(userStore.user?.customerName === "Mepz"||userStore.user?.customerName === "TNCA") && (name === "AssetTable") &&
                    <div style={{display: 'flex', alignItems: 'center',marginRight:'10px'}}>
                    <label style={{marginRight:'8px',fontSize:'16px', fontWeight:'bold'}}>No of Rows:</label>
                    <Dropdown
                      fluid
                      selection
                      style={{width:"60px"}}
                      options={rowsOption}
                      value={selectedRow}
                      onChange={(e, { value }) => {
                        const newValue = typeof value === 'string' ? parseFloat(value) : value;
                        if (typeof newValue === 'number' && !isNaN(newValue)) {
                          setPostsPerPage(newValue);
                          setSelectedRow(newValue);
                          if(filters.length > 0){
                            const filterValues = filters
                              .filter((filter:any) => 
                                filter.column.trim() !== '' &&
                                filter.operator.trim() !== '' &&
                                filter.value.trim() !== ''
                              ) // Only include filters with non-empty column, operator, and value
                              .map((filter:any) => ({
                                colName: filter.column,
                                filterType: filter.operator,
                                filterValue: filter.value
                              }));
                            activityStore.MepzLoadActivities(1, newValue,filterValues)
                          }else{
                            activityStore.MepzLoadActivities(1, newValue,[])
                          }
                          
                        }
                      }}
                    />
                    </div>
                    }
                    <DynamicTableCSVReport
                      tableData={tabledata}
                      tableName={tableName}
                    />
                  </div>
                )}
                {name !== 'SmartTracker' && (
                  <Icon
                    // onClick={() => dashboardStore.reportsConfigurationOpen(true)}
                    onClick={handleChange}
                    corner="bottom right"
                    size="large"
                    circular
                    inverted
                    color="teal"
                    name="settings"
                  />
                )}
              </div>
            </div>
          </Segment>
          {tableName === 'SmartTracker' &&
            TrackingReportStore.bindComponent.model &&
              <SmarttrackerComponents />
            }
        </Segment>
      ) : (
        //  <Segment className={tableName === "ReportsTable"?"table-height-reports":"table-height"}>
        <>
          <Segment
            basic
            className={
              tableName === 'ReportsTable' || tableName === 'SmartTracker'
                ? 'dynamictableoverflow-reports'
                : 'dynamictableoverflow-mobile'
            }
          >
            {/* <Segment basic className="dynamictableoverflow-mobile"> */}

            {dashboardStore.dashboard.reportsConfiguration === true ? (
              <ReportsModalForMetaData />
            ) : null}

            <Table sortable selectable celled singleLine padded="very">
              <Table.Header>
                <Table.Row>
                  {tabledHeaders?.map((tablehead: any, index: number) => {
                    return (
                      <Table.HeaderCell>
                        {' '}
                        <SearchInputData
                          tablehead={tablehead}
                          tablename={tableName}
                          index={index}
                          loader={
                            !(
                              reportStore.loadingDataReport ||
                              dashboardStore.dashboard.loadingCount ||
                              reportStore.loadMetadataReportComponent
                            )
                          }
                        />{' '}
                      </Table.HeaderCell>
                    );
                  })}
                </Table.Row>
              </Table.Header>

              <Table.Header>
                <Table.Row>
                  {tabledHeaders?.map((tablehead: any) => {
                    return (
                      <Table.HeaderCell>
                        {' '}
                        <SortData
                          header={tablehead}
                          tableName={tableName}
                          pageNum={pageNumData}
                          sortHandler={() => {}}
                        />{' '}
                      </Table.HeaderCell>
                    );
                  })}
                </Table.Row>
              </Table.Header>
              <Table.Body className="tabletexttruncate">
                {tabledata
                  // .filter(filterFunc)
                  .slice(
                    parseInt(state.currentPages, 10) *
                      parseInt(postsPerPage, 10) -
                      parseInt(postsPerPage, 10),
                    parseInt(state.currentPages, 10) *
                      parseInt(postsPerPage, 10),
                  ).length !== 0 ? (
                  tabledata
                    // .filter(filterFunc)
                    .slice(
                      parseInt(state.currentPages, 10) *
                        parseInt(postsPerPage, 10) -
                        parseInt(postsPerPage, 10),
                      parseInt(state.currentPages, 10) *
                        parseInt(postsPerPage, 10),
                    )
                    .map((rowData: any) => (
                      <Table.Row
                        key={rowData['id']}
                        active={rowData['id'] === TrackingReportStore.ActiveRowId}
                        onClick={() => getClickedValue(rowData, tableName)}
                        //  onMouseOver={() => setHoverRowId(rowData["id"])}
                      >
                        {tabledHeaders?.map((i: any) => (
                          <>
                            {user?.customerName === 'LVP CMS - AM' ? (
                              <>
                                {i.toLowerCase() ===
                                  'physical_location_vault' ||
                                i.toLowerCase() === 'asset_In_Vault' ? (
                                  <></>
                                ) : i.toLowerCase() ===
                                  'physical_location_room' ? (
                                  <Table.Cell key={i}>
                                    {rowData[`physical_location_vault`]}
                                  </Table.Cell>
                                ) : i.toLowerCase() === 'asset_in_room' ? (
                                  <Table.Cell key={i}>
                                    {rowData[`asset_In_Vault`]}
                                  </Table.Cell>
                                ) : (
                                  <Table.Cell key={i}>{rowData[i]}</Table.Cell>
                                )}
                              </>
                            ) : (
                              <Table.Cell key={i}>{rowData[i]}</Table.Cell>
                            )}
                          </>
                        ))}
                      </Table.Row>
                    ))
                ) : (
                  <Table.Row
                    style={{
                      height: '20vh',
                      overflow: 'hidden',
                    }}
                  >
                    <Table.Cell
                      colSpan={
                        data.length > 0 ? Object.keys(data[0]).length : 9
                      }
                      collapsing
                    >
                      <p className="tableEmptyData">Sorry, no data to show</p>
                    </Table.Cell>
                  </Table.Row>
                )}
              </Table.Body>
              {/* } */}
            </Table>

            {/* </Segment> */}
          </Segment>
          <div className="dynamicTableFooter">
            <Pagination
              disabled={
                reportStore.loadingDataReport ||
                dashboardStore.dashboard.loadingCount ||
                reportStore.loadMetadataReportComponent
              }
              //  style={{marginRight: "62px"}}
              activePage={pageNumData}
              // firstItem={null}
              // lastItem={null}
              // pointing
              // secondary
              totalPages={Math.ceil(countData / postsPerPage)}
              onPageChange={(event, data) => pageFunc(data.activePage)}
            />
            <div>
              <DynamicTableCSVReport
                tableData={tabledata}
                tableName={tableName}
              />
              <div>
                <Icon
                  onClick={handleChange}
                  corner="bottom right"
                  size="large"
                  circular
                  inverted
                  color="teal"
                  name="settings"
                />
              </div>
            </div>
          </div>
        </>
      )}
    </p>
  );
}
export default observer(DynamicTableComponentForMetaData);
